import { defineCustomElements } from "@jobtarget/base-ui/loader";

defineCustomElements();